import { Box, LoadingOverlay } from "@mantine/core";
import { pickBy } from "lodash";
import { useEffect, useMemo } from "react";
import { useLoaderState } from "../hooks/useLoader";

const LoadingOverlayProvider = (props: React.PropsWithChildren) => {
  const { children } = props;
  const { visible } = useLoaderState();

  const enabledLoadingState = useMemo(() => {
    return pickBy(visible, (v) => v);
  }, [visible]);

  const isLoading = useMemo(() => {
    return Object.values(visible).some((v) => v);
  }, [visible]);

  const enabledLoadingKeys = useMemo(() => {
    return Object.keys(enabledLoadingState);
  }, [enabledLoadingState]);

  /**
   * Loader가 보일때 스크롤을 방지함
   */
  useEffect(() => {
    document.body.style.overflow = isLoading ? "hidden" : "inherit";
  }, [isLoading]);

  return (
    <Box className="loading-overlay-provider">
      <LoadingOverlay
        className={enabledLoadingKeys.map((k) => `loading-${k}`).join(" ")}
        visible={!!isLoading}
      />
      {children}
    </Box>
  );
};

export default LoadingOverlayProvider;
